import React, { useEffect } from 'react';
import Tab from '../../../Components/Tab/Tab';
import './Menu.scss';
import { alertRef } from '../../../App';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const routeList = {
    '/hotel-order/info': '운영정보',
    '/hotel-order/setting': '설정',
    '/hotel-order/menu': '메뉴관리',
    '/hotel-order/option': '옵션관리',
    '/hotel-order/soldout/menu': '메뉴품절관리',
    '/hotel-order/soldout/option': '옵션품절관리',
    '/hotel-order/menu-image': '메뉴이미지관리',
}

const Menu = (props) => {
    const [name, setName] = React.useState('store-info')
    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();

    const tabRoute = [
        { route: 'info', header: '운영정보' },
        { route: 'setting', header: '설정' },
        { route: 'menu', header: '메뉴관리' },
        { route: 'option', header: '옵션관리' },
        { route: 'soldout/menu', header: '메뉴품절관리' },
        { route: 'soldout/option', header: '옵션품절관리' },
        { route: 'menu-image', header: '메뉴이미지관리' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>호텔 오더 {'>'} 메뉴관리 {'>'}</p>
                <p className='header-name'>{routeList[route]}</p>
            </div>
            <Tab
                routes={tabRoute}
                current={route.replace('/hotel-order/', '')}
                onTabChange={(name) => { setName(name); navigate(`/hotel-order/${name}`) }}
                renderItems={{
                    'info': <Outlet />,
                    'setting': <Outlet />,
                    'menu': <Outlet />,
                    'option': <Outlet />,
                    'soldout/menu': <Outlet />,
                    'soldout/option': <Outlet />,
                    'menu-image': <Outlet />,
                }}
            />
        </div>
    )
}

export default Menu;